import { getUserAgentString } from "./utils.mjs";
var OS_TYPE = /* @__PURE__ */ ((OS_TYPE2) => {
  OS_TYPE2["ANDROID"] = "ANDROID";
  OS_TYPE2["IOS"] = "IOS";
  OS_TYPE2["UNKNOWN"] = "UNKNOWN";
  return OS_TYPE2;
})(OS_TYPE || {});
function isAndroid(userAgent) {
  const ua = getUserAgentString(userAgent);
  return /Android|An\//i.test(ua);
}
function isIos(userAgent) {
  const ua = getUserAgentString(userAgent);
  return /iPhone|iPad|iPod|Io\//i.test(ua);
}
function getOsVersion(userAgent) {
  const ua = getUserAgentString(userAgent);
  let matches;
  let version;
  if (isAndroid(ua)) {
    matches = ua.match(/Android (\d+(?:\.\d+){0,2})/i);
    if (matches && matches[1]) {
      version = matches[1];
      return version;
    }
  }
  if (isIos(ua)) {
    matches = ua.match(/iPhone OS (\d+(?:_\d+){0,2})/i);
    if (matches && matches[1]) {
      version = matches[1].replace(/_/g, ".");
      return version;
    }
  }
  return "0.0.0";
}
function getOsName(userAgent) {
  const ua = getUserAgentString(userAgent);
  if (isAndroid(ua)) {
    return "ANDROID";
  } else if (isIos(ua)) {
    return "IOS";
  }
  return "UNKNOWN";
}
function getOsInfo(userAgent) {
  const ua = getUserAgentString(userAgent);
  return { name: getOsName(ua), version: getOsVersion(ua) };
}
export {
  OS_TYPE,
  getOsInfo,
  getOsName,
  getOsVersion,
  isAndroid,
  isIos
};
